import { NB } from '@cerebral-inc/ui';
import { IQuotesCarouselProps } from './types';
import { QuotesCarousel } from './QuotesCarousel';

const { Text, Flex, Link } = NB;
const Testimonials = ({ quotes }: IQuotesCarouselProps) => {
  return (
    <Flex bgColor="#F2F5FF" py={{ base: '64px', lg: '96px' }}>
      <Flex alignItems="center" mb={{ base: '24px', sm: '32px' }}>
        <Text
          color="#1C1E21"
          fontSize={{ base: '24px', sm: '28px' }}
          fontWeight={600}
          lineHeight={{ base: '28px', sm: '32px' }}
          fontFamily="Poppins"
        >
          Success stories
        </Text>
      </Flex>
      <QuotesCarousel quotes={quotes} />
      <Flex alignItems="center">
        <Link
          href={`${process.env.REACT_APP_HOME_PAGE_URL}/testimonials`}
          lineHeight="24px"
          _text={{
            color: '#51459e',
            fontSize: '14px',
            fontWeight: 600,
            fontFamily: 'Poppins'
          }}
          mt="48px"
        >
          See what else people are saying
        </Link>
      </Flex>
    </Flex>
  );
};

export default Testimonials;
